export default "./images/survio-2H15k-assets-folder-opened-24.svg";